import React from "react";
import styled from "styled-components";

const GridWrapper = styled.div<{ maxListHeight: string | number }>`
  display: flex;
  justify-content: center;
  max-height: ${props => props.maxListHeight}px;
  overflow-y: scroll;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 290px;
  margin-top: 10px;
`;
export interface MenuItem {
  key: string;
  onSelect: () => void;
  searchValues: string[];
  render: (props: any) => void;
}

interface TabSelectMenuGridPaneProps {
  activeRowIndex: string | number;
  menuItems: MenuItem[];
  maxListHeight: string | number;
}

export const TabSelectMenuGridPane = ({
  activeRowIndex,
  menuItems,
  maxListHeight
}: TabSelectMenuGridPaneProps) => {
  return (
    <GridWrapper maxListHeight={maxListHeight}>
      <Grid>
        {menuItems.map(({ onSelect, render, key }, index) =>
          render({
            active: index === activeRowIndex,
            onClick: onSelect,
            key
          })
        )}
      </Grid>
    </GridWrapper>
  );
};
